import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readAvailable(_this__u8e3s4, buffer, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  var result = _this__u8e3s4.d4k(buffer, offset, offset + length | 0);
  return result === -1 ? 0 : result;
}
//region block: exports
export {
  readAvailable as readAvailable27gpepp0hyyts,
};
//endregion

//# sourceMappingURL=Input.mjs.map
